<template>
  <div ref="rootEl" class="duel-event-log">
    <p v-if="lines.length === 0" class="duel-event-empty">
      {{ t('duel.log.empty') }}
    </p>
    <p
      v-for="line in lines"
      :key="line.id"
      class="duel-event-line"
    >
      {{ line.text }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { useI18n } from '../i18n/t'
import type { DuelLogLine } from '../game/duelEventLog'

const props = defineProps<{
  lines: DuelLogLine[]
}>()

const { t } = useI18n()
const rootEl = ref<HTMLElement | null>(null)

watch(
  () => props.lines.length,
  async () => {
    await nextTick()
    const el = rootEl.value
    if (el) el.scrollTop = el.scrollHeight
  },
)
</script>

<style scoped>
.duel-event-log {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 4px 8px 2px;
}

.duel-event-empty {
  margin: 8px 4px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 18px;
}

.duel-event-line {
  margin: 0;
  padding: 6px 8px;
  border-radius: 6px;
  background: rgba(15, 23, 42, 0.65);
  color: #e2e8f0;
  font-size: 13px;
  line-height: 18px;
  overflow-wrap: anywhere;
}
</style>
